// assets
import BankOutlined from '@ant-design/icons/BankOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import UserAddOutlined from '@ant-design/icons/UserAddOutlined';
import UserSwitchOutlined from '@ant-design/icons/UserSwitchOutlined';

// type
import { NavItemType } from '@/types/menu';

// icons
const icons = {
	BankOutlined,
	TeamOutlined,
	UserOutlined,
	UserAddOutlined,
	UserSwitchOutlined
};

// ==============================|| MENU ITEMS - ORGANIZAȚIE & UTILIZATORI ||============================== //
// Redesign raportat la .template/: grupul unic „Administrare acces" e împărțit în două —
// „Organizație" (administrațiile + invitațiile) și „Utilizatori" (conturile de utilizator
// web, pe roluri, + cetățenii). Rutele/permisiunile rămân ale noastre. „Roluri și
// permisiuni" s-a mutat în grupul „Administrare".

const organizatie: NavItemType = {
	id: 'group-organizatie',
	title: 'menu.organization',
	type: 'group',
	children: [
		{
			id: 'acces-administratii',
			title: 'menu.administrations',
			type: 'item',
			url: '/common/administrations',
			icon: icons.BankOutlined,
			requiredPermission: 'administrations:read'
		},
		{
			// Moderatori — web users hardcodat pe rolul moderator, rută dedicată (ca în template).
			id: 'acces-moderatori',
			title: 'menu.moderators',
			type: 'item',
			url: '/common/moderators',
			icon: icons.UserSwitchOutlined,
			requiredPermission: 'users:read'
		},
		{
			id: 'acces-invitatii',
			title: 'menu.invitations',
			type: 'item',
			url: '/common/invitations',
			icon: icons.UserAddOutlined,
			requiredPermission: 'invitations:read'
		}
	]
};

const utilizatori: NavItemType = {
	id: 'group-utilizatori',
	title: 'menu.users',
	type: 'group',
	children: [
		{
			id: 'acces-utilizatori',
			title: 'menu.internalAccounts',
			type: 'collapse',
			icon: icons.TeamOutlined,
			// Permisiunea stă pe collapse: copiii sunt regenerați dinamic (withWebUsersRoles) fără
			// chei. Moderatorii au secțiune dedicată (grupul Organizație) → excluși de aici.
			requiredPermission: 'users:read',
			children: [
				{
					id: 'acces-utilizatori-administratori',
					title: 'menu.administrators',
					type: 'item',
					url: '/common/users?roleId=2',
					requiredPermission: 'users:read'
				}
			]
		},
		{
			id: 'acces-cetateni',
			title: 'menu.citizens',
			type: 'item',
			url: '/common/users-app',
			icon: icons.UserOutlined,
			requiredPermission: 'users:read'
		}
	]
};

const accesGroups: NavItemType[] = [organizatie, utilizatori];

export default accesGroups;
